 <template>
  <b-modal
    id="modal_upload_xml"
    ref="modal_upload_xml"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    v-model="showModal"
  >
    <div class="col-md-12 col-sm-12">
      <label>Selecione ou arraste o arquivo </label>
      <b-form-file
        v-model="form.file"
        accept=".csv"
        :state="Boolean(form.file)"
        placeholder="Selecione ou arraste o arquivo aqui"
        drop-placeholder="Solte aqui"
      ></b-form-file>
    </div>
    <div slot="modal-footer" class="w-100">
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn @click="onStore()" variant="secondary" :disabled="isDisabled">
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
export default {
  components: {
    AvisoErros
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: ""
  },
  data() {
    return {
      modal_titulo: "Importar Região",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalGrupo: false,
      isFullscreen: false,
      file: null,
      avatar: null,
      data: [],
      errors_array: [],
      helpForm: new Form({
        statusRecord: [],
        params: []
      }),
      form: new FileForm({
        file: null,
        data: []
      }),
      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger"
      },
      moreParams: {}
    };
  },
  methods: {
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.data = [];
      this.data.push({ label: "file", value: this.form.file });
      this.form.data = this.data;
      this.form
        .upload("/api/regiao/import")
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
};
</script>
